export const RETRIEVE_DEMO_CLASS = "RETRIEVE_DEMO_CLASS";


export const DELETE_CLASS_DETAILS = "DELETE_CLASS_DETAILS";

export const RETRIEVE_ALL_COURSES = "RETRIEVE_ALL_COURSES";

export const RETRIEVE_DEMO_CLASS_REGISTARTION= "RETRIEVE_DEMO_CLASS_REGISTARTION";